import {
    GENERATE_SUBMIT_MYSQLTABLE_BEGIN,
    GENERATE_SUBMIT_MYSQLTABLE_SUCCESS,
    GENERATE_SUBMIT_MYSQLTABLE_FAILURE,
    GENERATE_SUBMIT_MYSQLTABLE_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

export function submitMysqltable(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: GENERATE_SUBMIT_MYSQLTABLE_BEGIN,
      });
  
    let apiurl = '/api/generate/node';

    const promise = new Promise((resolve, reject) => {
        request({
          method:'post',
          url:apiurl,
          data: params,
        }).then( data => {
            dispatch({
                type: GENERATE_SUBMIT_MYSQLTABLE_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: GENERATE_SUBMIT_MYSQLTABLE_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSubmitMysqltableError() {
    return {
      type: GENERATE_SUBMIT_MYSQLTABLE_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case GENERATE_SUBMIT_MYSQLTABLE_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          submitMysqltablePending: true,
          submitMysqltableError: null,
        };
  
      case GENERATE_SUBMIT_MYSQLTABLE_SUCCESS:
        // The request is success
        return {
          ...state,
          submitMysqltablePending: false,
          submitMysqltableError: null,
        };
  
      case GENERATE_SUBMIT_MYSQLTABLE_FAILURE:
        // The request is failed
        return {
          ...state,
          submitMysqltablePending: false,
          submitMysqltableError: action.data.error,
        };
  
      case GENERATE_SUBMIT_MYSQLTABLE_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          submitMysqltableError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/generate/redux/submitMysqltable.js